import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Icon } from "../../../icons";

export const StyledForm = styled("form")(({ theme }) => ({
    display: "flex",
    width: theme.space._1300,
    flexDirection: "column",
    alignItems: "center",
    gap: theme.space._500,
    alignSelf: "stretch",

    "@media (max-width: 600px)": {
        width: "100%"
    }
}));

export const PasswordRuleContainer = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: theme.space._100,
    alignSelf: "stretch",
}));

export const PasswordRule = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    gap: theme.space._200,
    alignSelf: "stretch",
    '&.is-checked div': {
        color: theme.colors["lime.500"]
    },
    '&.is-checked p': {
        color: theme.colors["lime.500"]
    }
}));

export const PasswordRuleIcon = styled(Icon)(({ theme }) => ({
    width: theme.space._400,
    height: theme.space._400,
    color: theme.colors["pink.400"],
}));

export const PasswordRuleText = styled(Typography)(({ theme }) => ({
    color: theme.colors["neutral.50"],
    fontSize: theme.fontSizes.sm,
    fontFamily: theme.fonts.default,
    fontWeight: theme.fontWeights.regular,
    lineHeight: theme.lineHeights.base,
}));